
export const isDevMachine = window.location.href.includes("localhost");

export const ajaxUri = isDevMachine?"http://localhost:8888/tagnotes/php/command.php":"/php/command.php"; ;

